// // components/ResetPassword.js
// import './ResetPassword.css'
// import { useState } from 'react';
// import { useNavigate, Navigate, useParams } from 'react-router-dom';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined' 
// import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';
// import Input from './Input';
// import Navbar from '../Navbar/Navbar';

import './ResetPassword.css';
import { useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import logoLine from '../../../images/LogoLine.svg';
import { useDispatch } from 'react-redux';
import { resetPassword } from '../../../actions/user';

export const PASSWORD_RULES = [
  { id: 'length',  label: '8 or more characters',           test: p => p.length >= 8 },
  { id: 'letter',  label: 'At least one letter',            test: p => /[a-zA-Z]/.test(p) },
  { id: 'number',  label: 'At least one number',            test: p => /\d/.test(p) },
  { id: 'special', label: 'At least one special character', test: p => /[^a-zA-Z0-9]/.test(p) },
];

/** @param {{ open: boolean }} props */
function EyeIcon({ open }) {
  return open ? (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  ) : (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  );
}

/**
 * Page for setting a new password via a reset link.
 * Reads the reset token from the url
 */
function ResetPassword() {
    const navigate = useNavigate();
    const { token } = useParams();
    const dispatch = useDispatch();

    const user = JSON.parse(localStorage.getItem('profile'))

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [showPw, setShowPw] = useState(false);
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    // Error message for failed reset
    const [errorMessage, setErrorMessage] = useState("")

    const pwChecks = PASSWORD_RULES.map(r => ({ ...r, passed: r.test(password) }));
    const pwValid = pwChecks.every(c => c.passed);

    const handleSubmit = (e) => {
        e.preventDefault();
        const errs = {};
        if (!pwValid) errs.password = 'Password does not meet all requirements';
        if (confirm !== password) errs.confirm = 'Passwords do not match';
        setErrors(errs);
        if (Object.keys(errs).length) return;
        dispatch(resetPassword(password, password, token, navigate, setErrorMessage))

        setSubmitted(true);
    };

    if (user) {
        return ( <Navigate replace={true} to="/posts" />)
    } 
    else {
        return (
            <div className="rp-page">
            <header className="rp-header">
                <Link to="/" className="rp-logo" aria-label="IClimbTrees home">
                <img src={logoLine} alt="IClimbTrees" height="32" />
                </Link>
            </header>

            <main className="rp-main">
                <div className="rp-card">
                {submitted ? (
                    <>
                    <div className="rp-success__icon" aria-hidden="true">✓</div>
                    <h1 className="rp-card__title">Password updated</h1>
                    <p className="rp-success__body">
                        Your password has been changed. You can now sign in with your new password.
                    </p>
                    <button
                        type="button"
                        className="rp-btn rp-btn--primary"
                        onClick={() => navigate('/')}
                    >
                        Back to home
                    </button>
                    </>
                ) : (
                    <>
                    <h1 className="rp-card__title">Set new password</h1>
                    <p className="rp-card__subtitle">
                        Choose a strong password for your account.
                    </p>

                    <form className="rp-form" onSubmit={handleSubmit} noValidate>
                         {errorMessage && (
                            <div className="auth-error-banner" role="alert">
                            <span>{errorMessage}</span>
                            <button
                                type="button"
                                className="auth-error-banner__close"
                                onClick={() => setErrorMessage('')}
                                aria-label="Dismiss error"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
                                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                            </button>
                            </div>
                        )}
                        <div className="rp-field">
                        <label className="rp-field__label" htmlFor="rp-password">
                            New password
                        </label>
                        <div className="rp-field__pw-wrap">
                            <input
                            id="rp-password"
                            className={`rp-field__input${errors.password ? ' rp-field__input--error' : ''}`}
                            type={showPw ? 'text' : 'password'}
                            autoComplete="new-password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="••••••••"
                            />
                            <button
                            type="button"
                            className="rp-field__pw-toggle"
                            onClick={() => setShowPw(v => !v)}
                            aria-label={showPw ? 'Hide password' : 'Show password'}
                            >
                            <EyeIcon open={showPw} />
                            </button>
                        </div>
                        {errors.password && (
                            <span className="rp-field__error">{errors.password}</span>
                        )}

                        <ul className="rp-pw-rules">
                            {pwChecks.map(c => {
                            const hasInput = password.length > 0;
                            const state = hasInput ? (c.passed ? 'ok' : 'fail') : '';
                            return (
                                <li key={c.id} className={`rp-pw-rule${state ? ` rp-pw-rule--${state}` : ''}`}>
                                <span className="rp-pw-rule__icon" aria-hidden="true">
                                    {hasInput ? (c.passed ? '✓' : '✗') : '·'}
                                </span>
                                {c.label}
                                </li>
                            );
                            })}
                        </ul>
                        </div>

                        <div className="rp-field">
                        <label className="rp-field__label" htmlFor="rp-confirm">
                            Confirm new password
                        </label>
                        <div className="rp-field__pw-wrap">
                            <input
                            id="rp-confirm"
                            className={`rp-field__input${errors.confirm ? ' rp-field__input--error' : ''}`}
                            type={showPw ? 'text' : 'password'}
                            autoComplete="new-password"
                            value={confirm}
                            onChange={e => {setConfirm(e.target.value)}}
                            placeholder="••••••••"
                            />
                            <button
                            type="button"
                            className="rp-field__pw-toggle"
                            onClick={() => setShowPw(v => !v)}
                            aria-label={showPw ? 'Hide password' : 'Show password'}
                            >
                            <EyeIcon open={showPw} />
                            </button>
                        </div>
                        {errors.confirm && (
                            <span className="rp-field__error">{errors.confirm}</span>
                        )}
                        </div>

                        <button type="submit" className="rp-btn rp-btn--primary rp-btn--full">
                        Set new password
                        </button>
                    </form>

                    <p className="rp-back">
                        <Link to="/" className="rp-back__link">← Back to home</Link>
                    </p>
                    </>
                )}
                </div>
            </main>
            </div>
        );
    }
}


export default ResetPassword; 